import { render, staticRenderFns } from "./TrainOfVideo2.vue?vue&type=template&id=18f5c0bc"
import script from "./TrainOfVideo2.vue?vue&type=script&lang=js"
export * from "./TrainOfVideo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports